import { useTranslation } from '@/i18n/hook';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="md:col-span-2">
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">CSSBuy Spreadsheet</h3>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-md">
              {t('footer.disclaimer')}
            </p>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-3">{t('nav.guides')}</h4>
            <div className="flex flex-col gap-2">
              <Link to="/article/cssbuy-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t('nav.article')}</Link>
              <span className="text-sm text-foreground-600">{t('nav.shipping')}</span>
              <span className="text-sm text-foreground-600">{t('nav.qc')}</span>
              <span className="text-sm text-foreground-600">{t('nav.safety')}</span>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-3">Legal</h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-foreground-600">{t('footer.privacy')}</span>
              <span className="text-sm text-foreground-600">{t('footer.terms')}</span>
              <span className="text-sm text-foreground-600">{t('footer.contact')}</span>
            </div>
          </div>
        </div>
        <div className="border-t border-background-200/70 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 CSSBuy Spreadsheet. {t('footer.rights')}
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">
              kaspreadsheet.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}